import dayjs from 'hb-react/shared/utils/dayjs/dayjs';

export const fewMonthsAgo = (numberOfMonths, date = new Date()) =>
  new Date(date.setMonth(date.getMonth() - numberOfMonths)).toUTCString();

export const getTimezoneId = (allTimezones, receivedTimezone) => {
  const selectedTimezone = allTimezones?.find(
    (timezone) =>
      receivedTimezone === timezone.id ||
      receivedTimezone === timezone.tzinfo_name,
  );

  return selectedTimezone?.id || '';
};

export const getFormattedDate = (date) => {
  if (date) {
    return dayjs.utc(date).format('YYYY-MM-DD'); // use UTC to ignore timezone from date
  }

  return date;
};
